(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin_city_smartb_s2_s2_automate_dsl.js', './kotlin_kotlin.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin_city_smartb_s2_s2_automate_dsl.js'), require('./kotlin_kotlin.js'));
  else {
    if (typeof kotlin_city_smartb_s2_s2_automate_dsl === 'undefined') {
      throw new Error("Error loading module 'kotlin_org_axessimpact_project_domain'. Its dependency 'kotlin_city_smartb_s2_s2_automate_dsl' was not found. Please, check whether 'kotlin_city_smartb_s2_s2_automate_dsl' is loaded prior to 'kotlin_org_axessimpact_project_domain'.");
    }
    if (typeof kotlin_kotlin === 'undefined') {
      throw new Error("Error loading module 'kotlin_org_axessimpact_project_domain'. Its dependency 'kotlin_kotlin' was not found. Please, check whether 'kotlin_kotlin' is loaded prior to 'kotlin_org_axessimpact_project_domain'.");
    }
    root.kotlin_org_axessimpact_project_domain = factory(typeof kotlin_org_axessimpact_project_domain === 'undefined' ? {} : kotlin_org_axessimpact_project_domain, kotlin_city_smartb_s2_s2_automate_dsl, kotlin_kotlin);
  }
}(this, function (_, kotlin_city_smartb_s2_s2_automate_dsl, kotlin_kotlin) {
  //region block: imports
  var imul = Math.imul;
  var S2Role = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Role;
  var S2State = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2State;
  var S2Event = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Event;
  var S2InitCommand = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2InitCommand;
  var S2Command = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Command;
  var S2InitTransitionBuilder = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2InitTransitionBuilder;
  var getKClass = kotlin_kotlin.$crossModule$.getKClass;
  var S2Transition = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Transition;
  var Unit_getInstance = kotlin_kotlin.$crossModule$.Unit_getInstance;
  var S2TransitionBuilder = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2TransitionBuilder;
  var s2 = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.s2;
  var getStringHashCode = kotlin_kotlin.$crossModule$.getStringHashCode;
  var THROW_CCE = kotlin_kotlin.$crossModule$.THROW_CCE;
  var hashCode = kotlin_kotlin.$crossModule$.hashCode;
  var equals = kotlin_kotlin.$crossModule$.equals;
  var getNumberHashCode = kotlin_kotlin.$crossModule$.getNumberHashCode;
  //endregion
  'use strict';
  //region block: pre-declaration
  Created.prototype = Object.create(ProjectState.prototype);
  Created.prototype.constructor = Created;
  Published.prototype = Object.create(ProjectState.prototype);
  Published.prototype.constructor = Published;
  Closed.prototype = Object.create(ProjectState.prototype);
  Closed.prototype.constructor = Closed;
  //endregion
  function _get_S2Project__2743978423() {
    init_properties_S2Project_kt_3345084090();
    return S2Project;
  }
  var S2Project;
  function s2Project() {
    init_properties_S2Project_kt_3345084090();
    return _get_S2Project__2743978423();
  }
  function Admin() {
  }
  Admin.$metadata$ = {
    simpleName: 'AdminRole',
    kind: 'class',
    interfaces: [S2Role]
  };
  function Created() {
    Created_instance = this;
    ProjectState.call(this, 0);
  }
  Created.$metadata$ = {
    simpleName: 'Created',
    kind: 'object',
    interfaces: []
  };
  var Created_instance;
  function Created_getInstance() {
    if (Created_instance == null)
      new Created();
    return Created_instance;
  }
  function Published() {
    Published_instance = this;
    ProjectState.call(this, 1);
  }
  Published.$metadata$ = {
    simpleName: 'Published',
    kind: 'object',
    interfaces: []
  };
  var Published_instance;
  function Published_getInstance() {
    if (Published_instance == null)
      new Published();
    return Published_instance;
  }
  function Closed() {
    Closed_instance = this;
    ProjectState.call(this, 2);
  }
  Closed.$metadata$ = {
    simpleName: 'Closed',
    kind: 'object',
    interfaces: []
  };
  var Closed_instance;
  function Closed_getInstance() {
    if (Closed_instance == null)
      new Closed();
    return Closed_instance;
  }
  function ProjectState(position) {
    this.position_1 = position;
  }
  ProjectState.prototype._set_position__3963083214_ves4de_k$ = function (_set____804775014) {
    this.position_1 = _set____804775014;
  };
  ProjectState.prototype._get_position__3188952002_iahqv2_k$ = function () {
    return this.position_1;
  };
  ProjectState.prototype.equals = function (other) {
    var tmp;
    if (other instanceof ProjectState) {
      tmp = other.position === this.position;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ProjectState.prototype.hashCode = function () {
    return this.position;
  };
  ProjectState.$metadata$ = {
    simpleName: 'ProjectState',
    kind: 'class',
    interfaces: [S2State]
  };
  Object.defineProperty(ProjectState.prototype, 'position', {
    configurable: true,
    get: function () {
      return this._get_position__3188952002_iahqv2_k$();
    },
    set: function (value) {
      this._set_position__3963083214_ves4de_k$(value);
    }
  });
  function ProjectEvent() {
  }
  ProjectEvent.$metadata$ = {
    simpleName: 'ProjectEvent',
    kind: 'interface',
    interfaces: [S2Event]
  };
  function ProjectInitCommand() {
  }
  ProjectInitCommand.$metadata$ = {
    simpleName: 'ProjectInitCommand',
    kind: 'interface',
    interfaces: [S2InitCommand]
  };
  function ProjectCommand() {
  }
  ProjectCommand.$metadata$ = {
    simpleName: 'ProjectCommand',
    kind: 'interface',
    interfaces: [S2Command]
  };
  function S2Project$lambda() {
    return function ($this$s2) {
      $this$s2._set_name__589551916_2ji656_k$('ProjectS2');
      var builder_1 = new S2InitTransitionBuilder();
      {
        builder_1._set_to__3473241468_c5v2kc_k$(Created_getInstance());
        builder_1._set_role__593662113_xqqqxo_k$(new Admin());
      }
      var tmp$ret$0;
      $l$block: {
        var tmp0_to_3 = builder_1._get_to__1413131888_ndcbjk_k$();
        var tmp1_role_4 = builder_1._get_role__808279189_dd887p_k$();
        var tmp0_let_0_2 = new S2Transition(null, tmp0_to_3, tmp1_role_4, getKClass(ProjectCreateCommand));
        var tmp1_let_5 = $this$s2._get_transactions__188093078_33zhjq_k$();
        {
        }
        tmp$ret$0 = tmp1_let_5.add_1j60pz_k$(tmp0_let_0_2);
        break $l$block;
      }
      Unit_getInstance();
      var builder_1_0 = new S2TransitionBuilder();
      {
        builder_1_0._set_from__582672365_yh8l08_k$(Created_getInstance());
        builder_1_0._set_to__3473241468_c5v2kc_k$(Created_getInstance());
        builder_1_0._set_role__593662113_xqqqxo_k$(new Admin());
      }
      var tmp$ret$1;
      $l$block_0: {
        var tmp0_let_0_2_0 = new S2Transition(builder_1_0._get_from__797289441_d6oogx_k$(), builder_1_0._get_to__1413131888_ndcbjk_k$(), builder_1_0._get_role__808279189_dd887p_k$(), getKClass(ProjectUpdateCommand));
        var tmp1_let_3 = $this$s2._get_transactions__188093078_33zhjq_k$();
        {
        }
        tmp$ret$1 = tmp1_let_3.add_1j60pz_k$(tmp0_let_0_2_0);
        break $l$block_0;
      }
      Unit_getInstance();
      var builder_1_1 = new S2TransitionBuilder();
      {
        builder_1_1._set_from__582672365_yh8l08_k$(Created_getInstance());
        builder_1_1._set_to__3473241468_c5v2kc_k$(Published_getInstance());
        builder_1_1._set_role__593662113_xqqqxo_k$(new Admin());
      }
      var tmp$ret$2;
      $l$block_1: {
        var tmp0_let_0_2_1 = new S2Transition(builder_1_1._get_from__797289441_d6oogx_k$(), builder_1_1._get_to__1413131888_ndcbjk_k$(), builder_1_1._get_role__808279189_dd887p_k$(), getKClass(ProjectPublishCommand));
        var tmp1_let_3_0 = $this$s2._get_transactions__188093078_33zhjq_k$();
        {
        }
        tmp$ret$2 = tmp1_let_3_0.add_1j60pz_k$(tmp0_let_0_2_1);
        break $l$block_1;
      }
      Unit_getInstance();
      var builder_1_2 = new S2TransitionBuilder();
      {
        builder_1_2._set_from__582672365_yh8l08_k$(Published_getInstance());
        builder_1_2._set_to__3473241468_c5v2kc_k$(Closed_getInstance());
        builder_1_2._set_role__593662113_xqqqxo_k$(new Admin());
      }
      var tmp$ret$3;
      $l$block_2: {
        var tmp0_let_0_2_2 = new S2Transition(builder_1_2._get_from__797289441_d6oogx_k$(), builder_1_2._get_to__1413131888_ndcbjk_k$(), builder_1_2._get_role__808279189_dd887p_k$(), getKClass(ProjectCloseCommand));
        var tmp1_let_3_1 = $this$s2._get_transactions__188093078_33zhjq_k$();
        {
        }
        tmp$ret$3 = tmp1_let_3_1.add_1j60pz_k$(tmp0_let_0_2_2);
        break $l$block_2;
      }
      Unit_getInstance();
      return Unit_getInstance();
    };
  }
  var properties_initialized_S2Project_kt_66417686;
  function init_properties_S2Project_kt_3345084090() {
    if (!properties_initialized_S2Project_kt_66417686) {
      properties_initialized_S2Project_kt_66417686 = true;
      S2Project = s2(S2Project$lambda());
    }
  }
  function ProjectCloseCommandDTO() {
  }
  ProjectCloseCommandDTO.$metadata$ = {
    simpleName: 'ProjectCloseCommandDTO',
    kind: 'interface',
    interfaces: [ProjectCommand]
  };
  function ProjectClosedEventDTO() {
  }
  ProjectClosedEventDTO.$metadata$ = {
    simpleName: 'ProjectClosedEventDTO',
    kind: 'interface',
    interfaces: [ProjectEvent]
  };
  function ProjectCloseCommand(id) {
    this.id_1 = id;
  }
  ProjectCloseCommand.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  ProjectCloseCommand.prototype.toString = function () {
    return 'ProjectCloseCommand(id=' + this.id_1 + ')';
  };
  ProjectCloseCommand.prototype.hashCode = function () {
    return getStringHashCode(this.id_1);
  };
  ProjectCloseCommand.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProjectCloseCommand))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProjectCloseCommand ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    return true;
  };
  ProjectCloseCommand.$metadata$ = {
    simpleName: 'ProjectCloseCommand',
    kind: 'class',
    interfaces: [ProjectCloseCommandDTO]
  };
  Object.defineProperty(ProjectCloseCommand.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  function ProjectCreateCommandDTO() {
  }
  ProjectCreateCommandDTO.$metadata$ = {
    simpleName: 'ProjectCreateCommandDTO',
    kind: 'interface',
    interfaces: [ProjectInitCommand]
  };
  function ProjectCreateCommand(name, summary, description, image, land, stakeholders) {
    this.name_1 = name;
    this.summary_1 = summary;
    this.description_1 = description;
    this.image_1 = image;
    this.land_1 = land;
    this.stakeholders_1 = stakeholders;
  }
  ProjectCreateCommand.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  ProjectCreateCommand.prototype._get_summary__373729323_66ibe3_k$ = function () {
    return this.summary_1;
  };
  ProjectCreateCommand.prototype._get_description__4027823381_4f1tkb_k$ = function () {
    return this.description_1;
  };
  ProjectCreateCommand.prototype._get_image__3321984470_g3aecq_k$ = function () {
    return this.image_1;
  };
  ProjectCreateCommand.prototype._get_land__802322880_d9okao_k$ = function () {
    return this.land_1;
  };
  ProjectCreateCommand.prototype._get_stakeholders__2004695902_x5jl9a_k$ = function () {
    return this.stakeholders_1;
  };
  ProjectCreateCommand.prototype.toString = function () {
    return 'ProjectCreateCommand(name=' + this.name_1 + ', summary=' + this.summary_1 + ', description=' + this.description_1 + ', image=' + this.image_1 + ', land=' + this.land_1 + ', stakeholders=' + this.stakeholders_1 + ')';
  };
  ProjectCreateCommand.prototype.hashCode = function () {
    var result = getStringHashCode(this.name_1);
    result = imul(result, 31) + getStringHashCode(this.summary_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.description_1) | 0;
    result = imul(result, 31) + (this.image_1 == null ? 0 : getStringHashCode(this.image_1)) | 0;
    result = imul(result, 31) + this.land_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.stakeholders_1) | 0;
    return result;
  };
  ProjectCreateCommand.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProjectCreateCommand))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProjectCreateCommand ? other : THROW_CCE();
    if (!(this.name_1 === tmp0_other_with_cast.name_1))
      return false;
    if (!(this.summary_1 === tmp0_other_with_cast.summary_1))
      return false;
    if (!(this.description_1 === tmp0_other_with_cast.description_1))
      return false;
    if (!(this.image_1 == tmp0_other_with_cast.image_1))
      return false;
    if (!this.land_1.equals(tmp0_other_with_cast.land_1))
      return false;
    if (!equals(this.stakeholders_1, tmp0_other_with_cast.stakeholders_1))
      return false;
    return true;
  };
  ProjectCreateCommand.$metadata$ = {
    simpleName: 'ProjectCreateCommand',
    kind: 'class',
    interfaces: [ProjectCreateCommandDTO]
  };
  Object.defineProperty(ProjectCreateCommand.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(ProjectCreateCommand.prototype, 'summary', {
    configurable: true,
    get: function () {
      return this._get_summary__373729323_66ibe3_k$();
    }
  });
  Object.defineProperty(ProjectCreateCommand.prototype, 'description', {
    configurable: true,
    get: function () {
      return this._get_description__4027823381_4f1tkb_k$();
    }
  });
  Object.defineProperty(ProjectCreateCommand.prototype, 'image', {
    configurable: true,
    get: function () {
      return this._get_image__3321984470_g3aecq_k$();
    }
  });
  Object.defineProperty(ProjectCreateCommand.prototype, 'land', {
    configurable: true,
    get: function () {
      return this._get_land__802322880_d9okao_k$();
    }
  });
  Object.defineProperty(ProjectCreateCommand.prototype, 'stakeholders', {
    configurable: true,
    get: function () {
      return this._get_stakeholders__2004695902_x5jl9a_k$();
    }
  });
  function ProjectPublishCommandDTO() {
  }
  ProjectPublishCommandDTO.$metadata$ = {
    simpleName: 'ProjectPublishCommandDTO',
    kind: 'interface',
    interfaces: [ProjectCommand]
  };
  function ProjectPublishedEventDTO() {
  }
  ProjectPublishedEventDTO.$metadata$ = {
    simpleName: 'ProjectPublishedEventDTO',
    kind: 'interface',
    interfaces: [ProjectEvent]
  };
  function ProjectPublishCommand(id) {
    this.id_1 = id;
  }
  ProjectPublishCommand.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  ProjectPublishCommand.prototype.toString = function () {
    return 'ProjectPublishCommand(id=' + this.id_1 + ')';
  };
  ProjectPublishCommand.prototype.hashCode = function () {
    return getStringHashCode(this.id_1);
  };
  ProjectPublishCommand.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProjectPublishCommand))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProjectPublishCommand ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    return true;
  };
  ProjectPublishCommand.$metadata$ = {
    simpleName: 'ProjectPublishCommand',
    kind: 'class',
    interfaces: [ProjectPublishCommandDTO]
  };
  Object.defineProperty(ProjectPublishCommand.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  function ProjectUpdateCommandDTO() {
  }
  ProjectUpdateCommandDTO.$metadata$ = {
    simpleName: 'ProjectUpdateCommandDTO',
    kind: 'interface',
    interfaces: [ProjectCommand]
  };
  function ProjectUpdatedEventDTO() {
  }
  ProjectUpdatedEventDTO.$metadata$ = {
    simpleName: 'ProjectUpdatedEventDTO',
    kind: 'interface',
    interfaces: [ProjectEvent]
  };
  function ProjectUpdateCommand(id, name, summary, description, image, land, stakeholders) {
    this.id_1 = id;
    this.name_1 = name;
    this.summary_1 = summary;
    this.description_1 = description;
    this.image_1 = image;
    this.land_1 = land;
    this.stakeholders_1 = stakeholders;
  }
  ProjectUpdateCommand.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  ProjectUpdateCommand.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  ProjectUpdateCommand.prototype._get_summary__373729323_66ibe3_k$ = function () {
    return this.summary_1;
  };
  ProjectUpdateCommand.prototype._get_description__4027823381_4f1tkb_k$ = function () {
    return this.description_1;
  };
  ProjectUpdateCommand.prototype._get_image__3321984470_g3aecq_k$ = function () {
    return this.image_1;
  };
  ProjectUpdateCommand.prototype._get_land__802322880_d9okao_k$ = function () {
    return this.land_1;
  };
  ProjectUpdateCommand.prototype._get_stakeholders__2004695902_x5jl9a_k$ = function () {
    return this.stakeholders_1;
  };
  ProjectUpdateCommand.prototype.toString = function () {
    return 'ProjectUpdateCommand(id=' + this.id_1 + ', name=' + this.name_1 + ', summary=' + this.summary_1 + ', description=' + this.description_1 + ', image=' + this.image_1 + ', land=' + this.land_1 + ', stakeholders=' + this.stakeholders_1 + ')';
  };
  ProjectUpdateCommand.prototype.hashCode = function () {
    var result = getStringHashCode(this.id_1);
    result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.summary_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.description_1) | 0;
    result = imul(result, 31) + (this.image_1 == null ? 0 : getStringHashCode(this.image_1)) | 0;
    result = imul(result, 31) + this.land_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.stakeholders_1) | 0;
    return result;
  };
  ProjectUpdateCommand.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProjectUpdateCommand))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProjectUpdateCommand ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!(this.name_1 === tmp0_other_with_cast.name_1))
      return false;
    if (!(this.summary_1 === tmp0_other_with_cast.summary_1))
      return false;
    if (!(this.description_1 === tmp0_other_with_cast.description_1))
      return false;
    if (!(this.image_1 == tmp0_other_with_cast.image_1))
      return false;
    if (!this.land_1.equals(tmp0_other_with_cast.land_1))
      return false;
    if (!equals(this.stakeholders_1, tmp0_other_with_cast.stakeholders_1))
      return false;
    return true;
  };
  ProjectUpdateCommand.$metadata$ = {
    simpleName: 'ProjectUpdateCommand',
    kind: 'class',
    interfaces: [ProjectUpdateCommandDTO]
  };
  Object.defineProperty(ProjectUpdateCommand.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(ProjectUpdateCommand.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(ProjectUpdateCommand.prototype, 'summary', {
    configurable: true,
    get: function () {
      return this._get_summary__373729323_66ibe3_k$();
    }
  });
  Object.defineProperty(ProjectUpdateCommand.prototype, 'description', {
    configurable: true,
    get: function () {
      return this._get_description__4027823381_4f1tkb_k$();
    }
  });
  Object.defineProperty(ProjectUpdateCommand.prototype, 'image', {
    configurable: true,
    get: function () {
      return this._get_image__3321984470_g3aecq_k$();
    }
  });
  Object.defineProperty(ProjectUpdateCommand.prototype, 'land', {
    configurable: true,
    get: function () {
      return this._get_land__802322880_d9okao_k$();
    }
  });
  Object.defineProperty(ProjectUpdateCommand.prototype, 'stakeholders', {
    configurable: true,
    get: function () {
      return this._get_stakeholders__2004695902_x5jl9a_k$();
    }
  });
  function ContactDetailsDTO() {
  }
  ContactDetailsDTO.$metadata$ = {
    simpleName: 'ContactDetailsDTO',
    kind: 'interface',
    interfaces: []
  };
  function ContactDetails() {
  }
  ContactDetails.prototype.hashCode = function () {
    var result = this.address_1 == null ? 0 : getStringHashCode(this.address_1);
    result = imul(result, 31) + (this.phone_1 == null ? 0 : getStringHashCode(this.phone_1)) | 0;
    result = imul(result, 31) + (this.email_1 == null ? 0 : getStringHashCode(this.email_1)) | 0;
    result = imul(result, 31) + (this.website_1 == null ? 0 : getStringHashCode(this.website_1)) | 0;
    return result;
  };
  ContactDetails.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ContactDetails))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ContactDetails ? other : THROW_CCE();
    if (!(this.address_1 == tmp0_other_with_cast.address_1))
      return false;
    if (!(this.phone_1 == tmp0_other_with_cast.phone_1))
      return false;
    if (!(this.email_1 == tmp0_other_with_cast.email_1))
      return false;
    if (!(this.website_1 == tmp0_other_with_cast.website_1))
      return false;
    return true;
  };
  ContactDetails.$metadata$ = {
    simpleName: 'ContactDetails',
    kind: 'class',
    interfaces: [ContactDetailsDTO]
  };
  function LandDTO() {
  }
  LandDTO.$metadata$ = {
    simpleName: 'LandDTO',
    kind: 'interface',
    interfaces: []
  };
  function Land() {
  }
  Land.prototype.hashCode = function () {
    var result = getNumberHashCode(this.surface_1);
    result = imul(result, 31) + this.owner_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.country_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.geoData_1) | 0;
    return result;
  };
  Land.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Land))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Land ? other : THROW_CCE();
    if (!equals(this.surface_1, tmp0_other_with_cast.surface_1))
      return false;
    if (!this.owner_1.equals(tmp0_other_with_cast.owner_1))
      return false;
    if (!(this.country_1 === tmp0_other_with_cast.country_1))
      return false;
    if (!(this.geoData_1 === tmp0_other_with_cast.geoData_1))
      return false;
    return true;
  };
  Land.$metadata$ = {
    simpleName: 'Land',
    kind: 'class',
    interfaces: [LandDTO]
  };
  function OrganizationDTO() {
  }
  OrganizationDTO.$metadata$ = {
    simpleName: 'OrganizationDTO',
    kind: 'interface',
    interfaces: []
  };
  function Organization() {
  }
  Organization.prototype.hashCode = function () {
    var result = getStringHashCode(this.name_1);
    result = imul(result, 31) + getStringHashCode(this.title_1) | 0;
    result = imul(result, 31) + this.contact_1.hashCode() | 0;
    return result;
  };
  Organization.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Organization))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Organization ? other : THROW_CCE();
    if (!(this.name_1 === tmp0_other_with_cast.name_1))
      return false;
    if (!(this.title_1 === tmp0_other_with_cast.title_1))
      return false;
    if (!this.contact_1.equals(tmp0_other_with_cast.contact_1))
      return false;
    return true;
  };
  Organization.$metadata$ = {
    simpleName: 'Organization',
    kind: 'class',
    interfaces: [OrganizationDTO]
  };
  function ProjectDetailsDTO() {
  }
  ProjectDetailsDTO.$metadata$ = {
    simpleName: 'ProjectDetailsDTO',
    kind: 'interface',
    interfaces: []
  };
  function SectorDTO() {
  }
  SectorDTO.$metadata$ = {
    simpleName: 'SectorDTO',
    kind: 'interface',
    interfaces: []
  };
  function Sector() {
  }
  Sector.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  Sector.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Sector) {
      tmp = other._get_id__1413120976_ndc34g_k$() === this._get_id__1413120976_ndc34g_k$();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Sector.prototype.hashCode = function () {
    return this._get_id__1413120976_ndc34g_k$();
  };
  Sector.$metadata$ = {
    simpleName: 'Sector',
    kind: 'class',
    interfaces: [SectorDTO]
  };
  Object.defineProperty(Sector.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$project = $org$axess$s2.project || ($org$axess$s2.project = {});
    var $org$axess$s2$project$domain = $org$axess$s2$project.domain || ($org$axess$s2$project.domain = {});
    $org$axess$s2$project$domain.s2Project = s2Project;
    $org$axess$s2$project$domain.Admin = Admin;
    $org$axess$s2$project$domain.ProjectState = ProjectState;
    Object.defineProperty($org$axess$s2$project$domain.ProjectState, 'Created', {
      configurable: true,
      get: Created_getInstance
    });
    Object.defineProperty($org$axess$s2$project$domain.ProjectState, 'Published', {
      configurable: true,
      get: Published_getInstance
    });
    Object.defineProperty($org$axess$s2$project$domain.ProjectState, 'Closed', {
      configurable: true,
      get: Closed_getInstance
    });
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$project = $org$axess$s2.project || ($org$axess$s2.project = {});
    var $org$axess$s2$project$domain = $org$axess$s2$project.domain || ($org$axess$s2$project.domain = {});
    var $org$axess$s2$project$domain$features = $org$axess$s2$project$domain.features || ($org$axess$s2$project$domain.features = {});
    var $org$axess$s2$project$domain$features$command = $org$axess$s2$project$domain$features.command || ($org$axess$s2$project$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$project = $org$axess$s2.project || ($org$axess$s2.project = {});
    var $org$axess$s2$project$domain = $org$axess$s2$project.domain || ($org$axess$s2$project.domain = {});
    var $org$axess$s2$project$domain$features = $org$axess$s2$project$domain.features || ($org$axess$s2$project$domain.features = {});
    var $org$axess$s2$project$domain$features$command = $org$axess$s2$project$domain$features.command || ($org$axess$s2$project$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$project = $org$axess$s2.project || ($org$axess$s2.project = {});
    var $org$axess$s2$project$domain = $org$axess$s2$project.domain || ($org$axess$s2$project.domain = {});
    var $org$axess$s2$project$domain$features = $org$axess$s2$project$domain.features || ($org$axess$s2$project$domain.features = {});
    var $org$axess$s2$project$domain$features$command = $org$axess$s2$project$domain$features.command || ($org$axess$s2$project$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$project = $org$axess$s2.project || ($org$axess$s2.project = {});
    var $org$axess$s2$project$domain = $org$axess$s2$project.domain || ($org$axess$s2$project.domain = {});
    var $org$axess$s2$project$domain$features = $org$axess$s2$project$domain.features || ($org$axess$s2$project$domain.features = {});
    var $org$axess$s2$project$domain$features$command = $org$axess$s2$project$domain$features.command || ($org$axess$s2$project$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$project = $org$axess$s2.project || ($org$axess$s2.project = {});
    var $org$axess$s2$project$domain = $org$axess$s2$project.domain || ($org$axess$s2$project.domain = {});
    var $org$axess$s2$project$domain$model = $org$axess$s2$project$domain.model || ($org$axess$s2$project$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$project = $org$axess$s2.project || ($org$axess$s2.project = {});
    var $org$axess$s2$project$domain = $org$axess$s2$project.domain || ($org$axess$s2$project.domain = {});
    var $org$axess$s2$project$domain$model = $org$axess$s2$project$domain.model || ($org$axess$s2$project$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$project = $org$axess$s2.project || ($org$axess$s2.project = {});
    var $org$axess$s2$project$domain = $org$axess$s2$project.domain || ($org$axess$s2$project.domain = {});
    var $org$axess$s2$project$domain$model = $org$axess$s2$project$domain.model || ($org$axess$s2$project$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$project = $org$axess$s2.project || ($org$axess$s2.project = {});
    var $org$axess$s2$project$domain = $org$axess$s2$project.domain || ($org$axess$s2$project.domain = {});
    var $org$axess$s2$project$domain$model = $org$axess$s2$project$domain.model || ($org$axess$s2$project$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$project = $org$axess$s2.project || ($org$axess$s2.project = {});
    var $org$axess$s2$project$domain = $org$axess$s2$project.domain || ($org$axess$s2$project.domain = {});
    var $org$axess$s2$project$domain$model = $org$axess$s2$project$domain.model || ($org$axess$s2$project$domain.model = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlin_org_axessimpact_project_domain.js.map